import { useTranslation } from 'react-i18next';
import { GetReservation200 } from '../../openapi/model';

function ReservationInfo({ reservation }: { reservation: GetReservation200 }) {
    const { t } = useTranslation();

    return (
        <div className="fireknife-reservation-info">
            <dl className="fireknife-reservation-info__dl">
                <div className="fireknife-reservation-info__item">
                    <dt className="fireknife-reservation-info__dt">
                        {t('widgetBookingInformation.lastName')}
                    </dt>
                    <dd className="fireknife-reservation-info__dd">
                        {reservation.genericBookingFields.lastName}
                    </dd>
                </div>
                <div className="fireknife-reservation-info__item">
                    <dt className="fireknife-reservation-info__dt">
                        {t('widgetBookingInformation.firstName')}
                    </dt>
                    <dd className="fireknife-reservation-info__dd">
                        {reservation.genericBookingFields.firstName}
                    </dd>
                </div>
                <div className="fireknife-reservation-info__item">
                    <dt className="fireknife-reservation-info__dt">
                        {t('widgetBookingInformation.email')}
                    </dt>
                    <dd className="fireknife-reservation-info__dd">
                        {reservation.genericBookingFields.email}
                    </dd>
                </div>
                <div className="fireknife-reservation-info__item">
                    <dt className="fireknife-reservation-info__dt">
                        {t('widgetBookingInformation.phone')}
                    </dt>
                    <dd className="fireknife-reservation-info__dd">
                        {reservation.genericBookingFields.phone}
                    </dd>
                </div>
            </dl>
        </div>
    );
}

export default ReservationInfo;
